import { Link } from "react-router-dom";
import { typeMeta } from "@/lib/content";
import type { ContentType } from "@/mocks/content";

const order: ContentType[] = ["animation", "character", "news"];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {order.map((type) => {
        const meta = typeMeta[type];
        return (
          <Link
            key={type}
            to={meta.path}
            className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-primary-600">
              <i className={`${meta.icon} text-2xl`} aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950">
                {meta.label}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">
                {meta.description}
              </p>
            </div>
            <span className="mt-auto flex items-center gap-1 text-sm font-medium text-accent-600">
              进入栏目
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </span>
          </Link>
        );
      })}
    </div>
  );
}